"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Functions = require("../core/Functions");

var _RootNode = require("../utils/RootNode");

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _PortalLayer = _interopRequireDefault(require("./internal/PortalLayer"));

var UILayer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UILayer, _React$Component);

  function UILayer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILayer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILayer).call(this, props));

    _this.handleCloseComplete = function () {
      var _this$props = _this.props,
          onCloseComplete = _this$props.onCloseComplete,
          transitionProps = _this$props.transitionProps;
      (0, _Functions.callIfPossible)(transitionProps && transitionProps.onCloseComplete);
      (0, _Functions.callIfPossible)(onCloseComplete);

      _this._rootNode.removeChild(_this._element);
    };

    _this.renderTree = function (content, forceTransitionOnMount) {
      var _this$props2 = _this.props,
          Transition = _this$props2.Transition,
          transitionProps = _this$props2.transitionProps;
      if (!Transition) return content;
      return _react.default.createElement(Transition, Object.assign({}, transitionProps, {
        onCloseComplete: _this.handleCloseComplete,
        transitionOnMount: forceTransitionOnMount || transitionProps && transitionProps.transitionOnMount
      }), content);
    };

    _this._rootNode = props.rootNode || (0, _RootNode.getDefaultNode)();
    _this._element = document.createElement('div');
    _this._element.className = 'private-layer';

    _this._element.setAttribute('data-layer-for', props['data-layer-for']);

    _this._rootNode.appendChild(_this._element);

    return _this;
  }

  (0, _createClass2.default)(UILayer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var Transition = this.props.Transition;
      if (!Transition) this.handleCloseComplete();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react.default.createElement(_PortalLayer.default, {
        element: this._element,
        renderTree: this.renderTree
      }, children);
    }
  }]);
  return UILayer;
}(_react.default.Component);

UILayer.propTypes = {
  children: _propTypes.default.node.isRequired,
  'data-layer-for': _propTypes.default.string,
  onCloseComplete: _propTypes.default.func,
  rootNode: _domElement.default,
  Transition: _propTypes.default.elementType,
  transitionProps: _propTypes.default.object
};
UILayer.displayName = 'UILayer';
var _default = UILayer;
exports.default = _default;
module.exports = exports.default;